// What opens under a frozen row's score, on the Lineup tab and the
// Scoreboard alike: the game as it stood at the freeze, how the frozen score
// was made, and what freezing turned out to be worth.
//
// Same rows as the ordinary score breakdown above it in both callers, so a
// frozen score is explained the way every other score is.
import React from "react";
import { describeFreeze } from "../../utils/freezeDetail";

const MUTED = "var(--color-text-muted)";
const signed = (n) => (n > 0 ? `+${n}` : `${n}`);
const TONE = { good: "var(--color-success-text)", bad: "var(--color-danger-text)", even: MUTED };

// spread, isCaptain and isTripPlay are for a freeze made before the scoreline
// was stored with it: the game is worked back from the frozen score instead.
function FreezeDetail({ detail, frozenPoints, currentPoints, gameOver, spread, isCaptain, isTripPlay }) {
  const { at, verdict } = describeFreeze({ detail, frozenPoints, currentPoints, gameOver, spread, isCaptain, isTripPlay });

  // The scoreline is only known for a freeze that stored it. One made before
  // that says so in the same slot, rather than showing the margin band the
  // breakdown below was worked back from as though it were a score.
  const scoreLine = at && !at.inferred ? at.scoreLine : "Not available";

  return (
    <>
      <div className="flex justify-between py-0.5">
        <span style={{ color: MUTED }}>At the freeze</span>
        <span style={{ fontWeight: 700, color: at && !at.inferred ? "var(--color-text-strong)" : MUTED }}>{scoreLine}</span>
      </div>
      {at && (
        <>
          {at.lines.map((line, i) => (
            <div key={i} className="flex justify-between py-0.5">
              <span style={{ color: MUTED }}>{line.label}</span>
              <span style={{ fontWeight: 600, color: line.points < 0 ? "var(--color-danger)" : line.points > 0 ? "var(--color-success)" : MUTED }}>
                {signed(line.points)}
              </span>
            </div>
          ))}
          <div className="flex justify-between py-0.5" style={{ borderTop: "1px solid var(--color-bg-subtle)", marginTop: 2, paddingTop: 4 }}>
            <span style={{ color: MUTED }}>Raw score</span>
            <span style={{ fontWeight: 700, color: "var(--color-text-strong)" }}>{signed(at.raw)}</span>
          </div>
          {at.multiplier && (
            <div className="flex justify-between py-0.5">
              <span style={{ color: MUTED }}>{at.multiplier.label}</span>
              <span style={{ fontWeight: 600, color: "var(--color-text-strong)" }}>&times;{at.multiplier.factor}</span>
            </div>
          )}
        </>
      )}
      <div className="flex justify-between py-0.5">
        <span style={{ color: "var(--color-freeze-text)", fontWeight: 700 }}>Frozen at</span>
        <span style={{ fontWeight: 700, color: "var(--color-freeze-text)" }}>{frozenPoints}</span>
      </div>
      {at && !at.reconciles && (
        <p style={{ color: MUTED, margin: "4px 0 0" }}>
          The frozen score came from the scoring update just before this scoreline, so the two can be a play apart.
        </p>
      )}

      {verdict && (
        <p style={{ color: TONE[verdict.tone], fontWeight: 600, margin: "6px 0 0" }}>
          {verdict.text}
        </p>
      )}
    </>
  );
}

export default FreezeDetail;
